module.exports = __webpack_public_path__ + "static/media/student.da21803a.png";